import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IBooking, IDashboardMidwifePayload } from 'src/app/models/dashboard.models';
import { ViewBookingComponent } from 'src/app/pages/shared-components/view-booking/view-booking.component';
declare var $: any;

@Component({
  selector: 'app-signed-up-clients',
  templateUrl: './signed-up-clients.component.html',
  styleUrls: ['./signed-up-clients.component.scss']
})
export class SignedUpClientsComponent implements OnInit {

  @Input() dashboard: IDashboardMidwifePayload;
  bookings: Array<IBooking> = [];
  @ViewChild(ViewBookingComponent) bookingModal: ViewBookingComponent;

  constructor() { }

  ngOnInit(): void {
    this.bookings = this.dashboard.bookings;
  }

  viewDetail(booking:IBooking){
    this.bookingModal.bookingDetails = booking;
    this.bookingModal.generateBookingDatesMidwife();
    $('#booking-details-midwife').modal('show');
  }

  refreshData(data: IBooking){
    this.bookings.forEach(booking=>{
      if(booking.bookingId == data.bookingId)
      {
        booking.startDate = data.startDate;
        booking.endDate = data.endDate;
      }
    })
  }

}
